/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { deleteBlog, fetchBlogById, getPaginatedBlogs, searchBlogs } from '../../../utils/api';
import SearchBar from '../../blogs/SearchBar';
import Loading from '../../../shared/Loading/Loading';
import Pagination from '../../blogs/Pagination';
import './FeaturedBlogs.css'
import { BiShowAlt } from 'react-icons/bi';
import { MdAddchart } from 'react-icons/md';
import { FiEdit3 } from 'react-icons/fi';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useDisclosure } from '@chakra-ui/react';
import Swal from 'sweetalert2';
import { toast } from 'react-hot-toast';
import AddBlog from '../../blogs/AddBlog';
import BlogUpdateForm from '../../blogs/BlogUpdateForm';

const FeaturedBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);


  // Outside the Component function
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
    });
    return `${formattedDate} ${formattedTime}`;
  };


  useEffect(() => {
    handleSearch();
  }, []);

  const handleSearch = async () => {
    try {
      setLoading(true);
      const searchResult = await searchBlogs(searchQuery, page, 6);
      setBlogs(searchResult.blogs);
      setTotalCount(searchResult.totalCount);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handlePagination = async (newPage) => {
    try {
      setLoading(true);
      const paginatedBlogs = await getPaginatedBlogs(newPage, 6);
      setBlogs(paginatedBlogs.blogs);
      setPage(newPage);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

// sourcery skip: combine-object-destructuring
  const { isOpen: isShowModalOpen, onOpen: onShowModalOpen, onClose: onShowModalClose } = useDisclosure();
  const { isOpen: isAddModalOpen, onOpen: onAddModalOpen, onClose: onAddModalClose } = useDisclosure();
  const { isOpen: isEditModalOpen, onOpen: onEditModalOpen, onClose: onEditModalClose } = useDisclosure();

  const handleShowModal = (blog) => {
    setSelectedBlog(blog);
    onShowModalOpen();
  };

  const handleAddModal = () => {
    onAddModalOpen();
    // Implement any additional logic or state handling for the Add modal
  };

  const handleEditModal = (blog) => {
    setSelectedBlog(blog);
    onEditModalOpen();
  };

  const handleDeleteBlog = async (blogId) => {
    if (blogs?.length === 1) {
      // Show a toast or alert message indicating that the last blog cannot be deleted
      toast.error("Cannot delete the last blog.");
      return;
    }
  
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
      confirmButtonColor: '#FFA001', // Add custom background color for the 'Yes' button
      confirmButtonMarginRight: '10px', // Add margin to the right of the 'Yes' button
      showClass: {
        popup: 'animate__animated animate__fadeInDown',
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteBlog(blogId);
          // Filter out the deleted blog from the blogs state
          setBlogs((prevBlogs) => prevBlogs.filter((blog) => blog._id !== blogId));
  
          Swal.fire({
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            icon: 'success',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
        } catch (error) {
          console.error('Failed to delete the blog', error);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: 'Cancelled',
          text: 'Your imaginary file is safe :)',
          icon: 'error',
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        });
      }
    });
  };
  
  

  return (
    <div className="flex justify-center">
      <div className="container mx-auto">

        {/* SearchBar component */}
        <SearchBar
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          handleSearch={handleSearch}
          loading={loading}
        />

        {loading ? (
          <Loading />
        ) : (
          <>
            {/* Display table data here */}
            <div className="flex items-center justify-center py-6 bg-gray-900">
              <div className="col-span-12">
                <div className="overflow-auto lg:overflow-visible ">
                  <table className="blog-table text-gray-400 border-separate space-y-6 text-sm">
                    <thead className="bg-gray-800 text-gray-500">
                      <tr>
                        <th className="blog-th p-3 hidden lg:block">Images</th>
                        <th className="blog-th p-3 text-left">Date</th>
                        <th className="blog-th p-3 text-left">Author</th>
                        <th className="blog-th p-3 text-left">Badges</th>
                        <th className="blog-th p-3 text-left flex items-center justify-around gap-2">
                          <p>Show</p>
                          <p>Add</p>
                          <p>Update</p>
                          <p>Remove</p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {blogs.map((blog) => (
                        <tr key={blog._id} className="blog-tr bg-gray-800">
                          <td className="blog-td p-3">
                            <div className="flex align-items-center">
                              <img
                                className="rounded-full h-12 w-12 object-cover"
                                src={blog.image} // Replace with your image URL
                                alt="blog image"
                              />
                              <div className="ml-3 hidden lg:block">
                                <div className='text-left'>{blog.title}</div>
                                <div className="text-gray-500 text-left">{blog?.desc?.length > 20 ? blog.desc.substring(0, 20) + '...' : blog.desc}</div>
                              </div>
                            </div>
                          </td>
                          {/* // Inside the map function where you render the table data */}
                          <td className="blog-td p-3">{formatDate(blog.date)}</td>
                          <td className="blog-td p-3 font-bold text-left">{blog.author}</td>
                          <td className="blog-td p-3">
                            <span className="bg-green-400 text-gray-50 rounded-md px-2">{blog.badges}</span>
                          </td>
                          <td className="blog-td p-3 flex justify-start gap-5 items-center mt-3">
                            <a href="#" className="text-gray-400 hover:text-gray-100 mr-2" onClick={() => handleShowModal(blog)}>
                              <BiShowAlt size={18} />
                            </a>
                            <a href="#" className="text-gray-400 hover:text-gray-100 ml-2" onClick={() => handleAddModal()}>
                              <MdAddchart />
                            </a>
                            <a href="#" className="text-gray-400 hover:text-gray-100 ml-2" onClick={() => handleEditModal(blog)}>
                              <FiEdit3 />
                            </a>
                            <a href="#" className="text-gray-400 hover:text-gray-100 ml-2" onClick={() => handleDeleteBlog(blog._id)}>
                              <RiDeleteBin6Line />
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Pagination component */}
            <div className="flex justify-center mt-4">
              <Pagination
                page={page}
                totalPages={Math.ceil(totalCount / 6)}
                onPageChange={handlePagination}
              />
            </div>
          </>
        )}

        {/* Show Modal */}
        {selectedBlog && (
          <Modal isCentered isOpen={isShowModalOpen} onClose={onShowModalClose} size='xl'>
            <ModalOverlay
              bg='blackAlpha.300'
              backdropFilter='blur(10px) hue-rotate(90deg)'
            />
            <ModalContent>

              <>

              <ModalCloseButton />

              <main class="mt-10">

              <div class="mb-4 md:mb-0 w-full max-w-screen-md mx-auto relative" style={{height: '24em'}}>
              <div class="absolute left-0 bottom-0 w-full h-full z-10"
              style={{
                backgroundImage: 'linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.7))',
              }}></div>
              <img src={selectedBlog.image} />
              <div class="p-4 absolute bottom-0 left-0 z-20">
              <a href="#"
                class="px-4 py-1 bg-black text-gray-200 inline-flex items-center justify-center mb-2">{selectedBlog.badges}</a>
              <h2 class="text-4xl font-semibold text-gray-100 leading-tight">
                {selectedBlog.title}
              </h2>
              <div class="flex mt-3">
                <div>
                  <p class="font-semibold text-gray-200 text-sm">Author {selectedBlog.author}</p>
                  <p class="font-semibold text-gray-400 text-xs">Published {formatDate(selectedBlog.date)}</p>

                </div>
              </div>
              </div>
              </div>

              <div class="px-4 lg:px-0 mt-12 text-gray-400 max-w-screen-md mx-auto text-lg leading-relaxed">


              <div class="border-l-4 border-warning px-4 mb-6 italic rounded">
              {selectedBlog.desc}
              </div>



              </div>
              </main>
              </>

            </ModalContent>
          </Modal>
        )}

        {/* Add Modal */}
        {/* Implement your Add modal content here */}
        <Modal isCentered isOpen={isAddModalOpen} onClose={onAddModalClose} size='2xl'>
          {/* Add modal content */}
          {/* Implement your Add modal content here */}
          <ModalOverlay
            bg='blackAlpha.300'
            backdropFilter='blur(10px) hue-rotate(90deg)'
          />
          <ModalContent>
            <ModalCloseButton />
            <ModalBody>
              {/* Add modal body */}
              {/* Implement your Add modal body content here */}
              <AddBlog onClose={onAddModalClose}/>
            </ModalBody>
          </ModalContent>
        </Modal>

      {/* Edit Modal */}
      <Modal isCentered isOpen={isEditModalOpen} onClose={onEditModalClose}>
          <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px) hue-rotate(90deg)" />
          <ModalContent>
            <ModalHeader color="whiteAlpha.800">Edit Blog</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {/* Display the BlogUpdateForm component */}
              {selectedBlog && (
                <BlogUpdateForm
                  blog={selectedBlog}
                  onUpdate={(updatedBlogData) => {
                    setSelectedBlog((prevBlog) => ({ ...prevBlog, ...updatedBlogData }));
                  }}
                  onClose={onEditModalClose}
                />
              )}
            </ModalBody>
          </ModalContent>
        </Modal>

      </div>
    </div>
  );
};

export default FeaturedBlogs;